module.exports = __webpack_public_path__ + "static/aws-partner-0e87bd6a9568b6df227886e92acce9e7.svg";